import { BoundTextField } from "lib/@components/binding/bound-components"

/**
 * Recipient input for a `text` requested field. Plain single-line text bound to `values.<field.id>`.
 * Also serves as the generic fallback control for unknown field types (see `requested-field-input.js`).
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 */
export function TextFieldInput({ field }) {
    return <BoundTextField field={`values.${field.id}`} noLabel size="small" />
}
